import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-6482').catch(console.error);
